import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/groupName`;

export const ROUTE: RouteDefinition = `${baseRoute}/groupName`;

export const URL = (): RouteDefinition => `${baseRoute}/groupName`;
